var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Link, Stack, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, ConfirmDialog, ErrorMessageBox, FallbackComponent, NumberInput } from '../../common';
import { SelectOrCustomField } from '../../common/selectOrCustomField';
import { CopyFromLocationDropdown } from '../common/CopyFromLocationDropdown';
import { LocationListPanel } from '../common/LocationListPanel';
import { WizardTable } from '../common/WizardTable';
import { FteSwitch } from '../common/fteSwitch';
import { OrgConfigStepContainer } from '../common/stepContainer';
import { usePersistingLocationSelect } from '../common/usePersistingLocationSelect';
import { MAX_TEXT_LENGTH } from '../constants';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { useConfiguredLocationIds, useLocationsAPI } from '../selectors';
import { BasedOnCalculation, LocationRoleType, ROLE_APPLIES_TO_T_KEYS, ROLE_TYPE_T_KEYS, RoleAppliesTo, saveLocationRoles, useCopyRolesFromAPI, useRolesAPI, useStaffingStatusAPI } from './selectors';
import { createDefaultFormState, createEmptyRole } from './types';
var ROLE_TYPES = [LocationRoleType.Supervisor, LocationRoleType.QualityAssurance, LocationRoleType.Trainer, LocationRoleType.WfmAnalyst, LocationRoleType.Recruiter, LocationRoleType.Custom];
var ROLE_APPLIES_TO_VALUES = [RoleAppliesTo.Queue, RoleAppliesTo.Site];
/** Unique key for a predefined role (custom roles are deduped by name instead). */
var roleKey = function (roleType) {
  return roleType;
};
var normalizeCustomName = function (name) {
  return name.trim().toLowerCase();
};
var isEmptyNewRole = function (r) {
  return r.isNew && !r.roleType && !r.roleAppliesTo && !r.customRoleName && r.ratio === null;
};
var hasDuplicateCustomNames = function (roles) {
  var seen = new Set();
  for (var _i = 0, roles_1 = roles; _i < roles_1.length; _i++) {
    var r = roles_1[_i];
    if (r.isDeleted || r.roleType !== LocationRoleType.Custom) continue;
    var name_1 = normalizeCustomName(r.customRoleName);
    if (!name_1) continue;
    if (seen.has(name_1)) return true;
    seen.add(name_1);
  }
  return false;
};
var hasDuplicateRoles = function (roles) {
  var seen = new Set();
  for (var _i = 0, roles_2 = roles; _i < roles_2.length; _i++) {
    var r = roles_2[_i];
    if (r.isDeleted || !r.roleType || r.roleType === LocationRoleType.Custom || !r.roleAppliesTo) continue;
    var key = roleKey(r.roleType);
    if (seen.has(key)) return true;
    seen.add(key);
  }
  return false;
};
/**
 * Returns the kind of duplicate found among the active roles, or null when all roles are unique.
 * - 'name': two custom roles share the same (case-insensitive) name
 * - 'role_type': two predefined roles share the same role type value
 */
var findDuplicateRoleKind = function (roles) {
  if (hasDuplicateCustomNames(roles)) return 'name';
  if (hasDuplicateRoles(roles)) return 'role_type';
  return null;
};
var getSaveErrorMessage = function (error, fallbackMessage) {
  var _a, _b;
  if (typeof error === 'object' && error !== null && 'response' in error) {
    var message = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
    if (Array.isArray(message) && message.length > 0) return message.join(', ');
    if (typeof message === 'string' && message.trim() !== '') return message;
  }
  return fallbackMessage;
};
var mapRoleItemToFormState = function (r) {
  var ratio;
  if (r.ratio === null || r.ratio === undefined) {
    ratio = null;
  } else if (typeof r.ratio === 'number') {
    ratio = r.ratio;
  } else {
    var parsed = Number(r.ratio);
    ratio = Number.isNaN(parsed) ? null : parsed;
  }
  var predefinedRoleTypes = new Set([LocationRoleType.Supervisor, LocationRoleType.QualityAssurance, LocationRoleType.Trainer, LocationRoleType.WfmAnalyst, LocationRoleType.Recruiter]);
  var isCustom = r.isCustom || r.roleType === LocationRoleType.Custom || !!r.roleType && !predefinedRoleTypes.has(r.roleType);
  return {
    id: r.id,
    roleType: isCustom ? LocationRoleType.Custom : r.roleType,
    customRoleName: isCustom ? r.roleName : '',
    roleAppliesTo: r.roleAppliesTo,
    basedOnCalculation: r.basedOnCalculation,
    ratio: ratio,
    isNew: false,
    isDirty: false,
    isDeleted: false
  };
};
var RoleRow = function (_a) {
  var _b, _c, _d, _e;
  var role = _a.role,
    onChange = _a.onChange,
    onDelete = _a.onDelete,
    disabledRoleTypes = _a.disabledRoleTypes;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'staffing'
  }).t;
  var roleTypeOptions = ROLE_TYPES.filter(function (type) {
    return type !== LocationRoleType.Custom;
  }).map(function (type) {
    return {
      id: type,
      name: String(t(ROLE_TYPE_T_KEYS[type], {
        defaultValue: type
      }))
    };
  });
  roleTypeOptions.push({
    id: LocationRoleType.Custom,
    name: String(t(ROLE_TYPE_T_KEYS[LocationRoleType.Custom], {
      defaultValue: 'Custom'
    }))
  });
  var isCustom = role.roleType === LocationRoleType.Custom;
  var appliesToOptions = ROLE_APPLIES_TO_VALUES.map(function (val) {
    return {
      id: val,
      name: String(t(ROLE_APPLIES_TO_T_KEYS[val], {
        defaultValue: val
      }))
    };
  });
  var handleAppliesToChange = function (value) {
    onChange(function (r) {
      var _a;
      return __assign(__assign({}, r), {
        roleAppliesTo: (_a = value) !== null && _a !== void 0 ? _a : '',
        isDirty: true
      });
    });
  };
  var handleCalcToggle = function () {
    onChange(function (r) {
      return __assign(__assign({}, r), {
        basedOnCalculation: r.basedOnCalculation === BasedOnCalculation.Headcount ? BasedOnCalculation.Fte : BasedOnCalculation.Headcount,
        isDirty: true
      });
    });
  };
  var isFte = role.basedOnCalculation === BasedOnCalculation.Fte;
  return _jsxs(TableRow, {
    children: [_jsx(TableCell, __assign({
      sx: {
        pl: 0,
        width: '20rem',
        verticalAlign: 'top'
      }
    }, {
      children: _jsx(SelectOrCustomField, {
        isCustom: isCustom,
        name: "roleType-".concat((_b = role.id) !== null && _b !== void 0 ? _b : role.customRoleName),
        value: role.roleType,
        options: roleTypeOptions,
        onChange: function (v) {
          return onChange(function (r) {
            var _a;
            return __assign(__assign({}, r), {
              roleType: (_a = v) !== null && _a !== void 0 ? _a : '',
              isDirty: true
            });
          });
        },
        onSelectChange: function (v) {
          return onChange(function (r) {
            var _a;
            return __assign(__assign({}, r), {
              roleType: (_a = v) !== null && _a !== void 0 ? _a : '',
              isDirty: true
            });
          });
        },
        customName: "customRoleName-".concat((_c = role.id) !== null && _c !== void 0 ? _c : 'new'),
        customValue: (_d = role.customRoleName) !== null && _d !== void 0 ? _d : '',
        onCustomChange: function (v) {
          return onChange(function (r) {
            return __assign(__assign({}, r), {
              roleType: v ? LocationRoleType.Custom : '',
              customRoleName: v || '',
              isDirty: true
            });
          });
        },
        customPlaceholder: t('roles.enterRoleName', {
          defaultValue: 'Enter role name'
        }),
        defaultValue: "",
        placeholder: t('roles.pleaseSelect', {
          defaultValue: 'Please select'
        }),
        maxLength: MAX_TEXT_LENGTH,
        getOptionDisabled: function (option) {
          return option.id !== LocationRoleType.Custom && !!(disabledRoleTypes === null || disabledRoleTypes === void 0 ? void 0 : disabledRoleTypes.has(roleKey(option.id)));
        }
      })
    })), _jsx(TableCell, __assign({
      sx: {
        minWidth: 160,
        verticalAlign: 'top'
      }
    }, {
      children: _jsx(Autocomplete, {
        size: "small",
        fullWidth: true,
        options: appliesToOptions,
        value: role.roleAppliesTo,
        getOptionValue: function (o) {
          return o.id;
        },
        getOptionLabel: function (o) {
          return o.name;
        },
        isOptionEqualToValue: function (o, v) {
          return o.id === v.id;
        },
        placeholder: t('roles.pleaseSelect', {
          defaultValue: 'Please select'
        }),
        onChange: handleAppliesToChange
      })
    })), _jsx(TableCell, __assign({
      sx: {
        minWidth: 110,
        verticalAlign: 'top'
      }
    }, {
      children: _jsx(NumberInput, {
        fullWidth: true,
        size: "small",
        value: (_e = role.ratio) !== null && _e !== void 0 ? _e : '',
        min: 1,
        max: 1000,
        decimal: 0,
        onChange: function (v) {
          return onChange(function (r) {
            return __assign(__assign({}, r), {
              ratio: typeof v === 'number' && !Number.isNaN(v) ? v : null,
              isDirty: true
            });
          });
        },
        inputProps: {
          style: {
            textAlign: 'center'
          }
        }
      })
    })), _jsx(TableCell, __assign({
      align: "center",
      sx: {
        p: '0 !important'
      }
    }, {
      children: _jsxs(Stack, __assign({
        direction: "row",
        alignItems: "center",
        justifyContent: "center",
        spacing: 1
      }, {
        children: [_jsx(Typography, __assign({
          color: isFte ? 'text.primary' : 'text.secondary'
        }, {
          children: t('roles.fte', {
            defaultValue: 'FTE'
          })
        })), _jsx(FteSwitch, {
          checked: !isFte,
          onChange: handleCalcToggle
        }), _jsx(Typography, __assign({
          color: isFte ? 'text.secondary' : 'text.primary'
        }, {
          children: t('roles.headcount', {
            defaultValue: 'Headcount'
          })
        }))]
      }))
    })), _jsx(TableCell, __assign({
      align: "center",
      sx: {
        p: '0 !important'
      }
    }, {
      children: _jsx(IconButton, __assign({
        size: "small",
        onClick: onDelete,
        sx: {
          color: function (theme) {
            return theme.palette.text.primary;
          },
          '&:hover': {
            color: function (theme) {
              return theme.palette.text.primary;
            },
            backgroundColor: function (theme) {
              return theme.palette.action.hover;
            }
          }
        }
      }, {
        children: _jsx(FontAwesomeIcon, {
          icon: "trash-can"
        })
      }))
    }))]
  });
};
var LocationConfigPanel = function (_a) {
  var form = _a.form,
    locationId = _a.locationId,
    allLocations = _a.allLocations,
    onChange = _a.onChange,
    onCopySuccess = _a.onCopySuccess;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'staffing'
  }).t;
  var _b = useState(null),
    deleteRoleIdx = _b[0],
    setDeleteRoleIdx = _b[1];
  var _c = useState(false),
    clearConfirmOpen = _c[0],
    setClearConfirmOpen = _c[1];
  var _d = useState(undefined),
    copyError = _d[0],
    setCopyError = _d[1];
  var dismissedCopyErrorRef = useRef(null);
  var _e = useState(0),
    copyDropdownKey = _e[0],
    setCopyDropdownKey = _e[1];
  var _f = useCopyRolesFromAPI(locationId),
    copyFromData = _f[0],
    doCopyFrom = _f[1],
    clearCopyFromData = _f[2];
  var handleCopyFrom = function (sourceLocationId) {
    dismissedCopyErrorRef.current = null;
    setCopyError(undefined);
    setCopyDropdownKey(function (k) {
      return k + 1;
    });
    doCopyFrom({
      sourceLocationId: sourceLocationId
    });
  };
  useEffect(function () {
    var copiedRoles = copyFromData.data;
    if (!copiedRoles) return;
    onChange(function (f) {
      return __assign(__assign({}, f), {
        roles: copiedRoles.length > 0 ? copiedRoles.map(mapRoleItemToFormState) : [createEmptyRole()],
        isDirty: false
      });
    });
    clearCopyFromData();
    onCopySuccess();
  }, [copyFromData.data, clearCopyFromData, onCopySuccess, onChange]);
  useEffect(function () {
    if (!copyFromData.error) {
      dismissedCopyErrorRef.current = null;
      return;
    }
    if (dismissedCopyErrorRef.current === copyFromData.error) return;
    var message = t('errors.copyFailed', {
      defaultValue: 'Failed to copy roles. Please try again.'
    });
    setCopyError(function (prev) {
      return (prev === null || prev === void 0 ? void 0 : prev.message) === message ? prev : {
        message: message
      };
    });
  }, [copyFromData.error, t]);
  var handleCloseCopyError = function () {
    dismissedCopyErrorRef.current = copyFromData.error;
    setCopyError(undefined);
  };
  var handleRoleChange = function (idx, updater) {
    onChange(function (f) {
      var roles = f.roles.map(function (r, i) {
        return i === idx ? updater(r) : r;
      });
      return __assign(__assign({}, f), {
        roles: roles,
        isDirty: true
      });
    });
  };
  var handleDeleteRole = function (idx) {
    setDeleteRoleIdx(idx);
  };
  var confirmDeleteRole = function () {
    if (deleteRoleIdx === null) return;
    onChange(function (f) {
      var role = f.roles[deleteRoleIdx];
      var roles;
      if (role.isNew) {
        roles = f.roles.filter(function (_, i) {
          return i !== deleteRoleIdx;
        });
      } else {
        roles = f.roles.map(function (r, i) {
          return i === deleteRoleIdx ? __assign(__assign({}, r), {
            isDeleted: true
          }) : r;
        });
      }
      if (roles.filter(function (r) {
        return !r.isDeleted;
      }).length === 0) {
        roles = __spreadArray(__spreadArray([], roles, true), [createEmptyRole()], false);
      }
      return __assign(__assign({}, f), {
        roles: roles,
        isDirty: true
      });
    });
    setDeleteRoleIdx(null);
  };
  var handleClearData = function () {
    onChange(function (f) {
      return __assign(__assign({}, f), {
        roles: __spreadArray(__spreadArray([], f.roles.filter(function (r) {
          return !r.isNew;
        }).map(function (r) {
          return __assign(__assign({}, r), {
            isDeleted: true
          });
        }), true), [createEmptyRole()], false),
        isDirty: true
      });
    });
    setClearConfirmOpen(false);
  };
  var visibleRoles = form.roles.filter(function (r) {
    return !r.isDeleted;
  });
  var showDuplicateNameError = hasDuplicateCustomNames(visibleRoles);
  return _jsxs(Box, {
    children: [_jsxs(Stack, __assign({
      direction: "row",
      alignItems: "center",
      justifyContent: "space-between",
      sx: {
        mb: 3
      },
      flexWrap: "wrap",
      useFlexGap: true
    }, {
      children: [_jsx(Typography, __assign({
        variant: "h3"
      }, {
        children: t('title', {
          defaultValue: 'Support Roles'
        })
      })), _jsx(CopyFromLocationDropdown, {
        locations: allLocations,
        currentLocationId: locationId,
        onCopy: handleCopyFrom,
        onClear: function () {
          return setClearConfirmOpen(true);
        },
        clearDisabled: visibleRoles.length === 0
      }, copyDropdownKey)]
    })), _jsx(ErrorMessageBox, {
      errors: [copyError],
      onClose: handleCloseCopyError,
      scrollTop: false
    }), _jsx(WizardTable, __assign({
      headers: _jsxs(_Fragment, {
        children: [_jsx(TableCell, {
          children: t('roleName', {
            defaultValue: 'Role name'
          })
        }), _jsx(TableCell, {
          children: t('roleAppliesTo', {
            defaultValue: 'Role applies to'
          })
        }), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: t('staffingRatio', {
            defaultValue: 'Staffing ratio'
          })
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: t('calculatedBasedOn', {
            defaultValue: 'Calculated based on'
          })
        })), _jsx(TableCell, {
          align: "center"
        })]
      })
    }, {
      children: _jsx(TableBody, {
        children: visibleRoles.map(function (role) {
          var actualIdx = form.roles.indexOf(role);
          var otherRoleTypes = new Set();
          visibleRoles.forEach(function (other) {
            if (other === role) return;
            if (other.roleType && other.roleType !== LocationRoleType.Custom) {
              otherRoleTypes.add(roleKey(other.roleType));
            }
          });
          return _jsx(RoleRow, {
            role: role,
            onChange: function (updater) {
              return handleRoleChange(actualIdx, updater);
            },
            onDelete: function () {
              return handleDeleteRole(actualIdx);
            },
            disabledRoleTypes: otherRoleTypes
          }, actualIdx);
        })
      })
    })), showDuplicateNameError && _jsx(Typography, __assign({
      variant: "body2",
      color: "error",
      sx: {
        mt: 2
      }
    }, {
      children: t('roles.uniqueNameError', {
        defaultValue: 'Role name must be unique.'
      })
    })), _jsx(Link, __assign({
      component: "button",
      onClick: function () {
        return onChange(function (f) {
          return __assign(__assign({}, f), {
            roles: __spreadArray(__spreadArray([], f.roles, true), [createEmptyRole()], false),
            isDirty: true
          });
        });
      },
      sx: {
        mt: 4,
        cursor: 'pointer',
        alignSelf: 'flex-start'
      }
    }, {
      children: t('addRole', {
        defaultValue: '+ Add role'
      })
    })), _jsx(ConfirmDialog, {
      open: deleteRoleIdx !== null,
      onClose: function () {
        return setDeleteRoleIdx(null);
      },
      title: t('deleteRole.title', {
        defaultValue: 'Remove role'
      }),
      message: t('deleteRole.message', {
        defaultValue: 'Are you sure you want to remove this role?'
      }),
      onConfirm: confirmDeleteRole,
      confirmButtonText: "yes",
      cancelButtonText: "cancel"
    }), _jsx(ConfirmDialog, {
      open: clearConfirmOpen,
      onClose: function () {
        return setClearConfirmOpen(false);
      },
      title: t('clearDataConfirm.title', {
        defaultValue: 'Clear support staff roles'
      }),
      message: t('clearDataConfirm.message', {
        defaultValue: 'Are you sure you want to remove all support staff roles for this location?'
      }),
      onConfirm: handleClearData,
      confirmButtonText: "yes",
      cancelButtonText: "cancel"
    })]
  });
};
export var StaffingStep = function () {
  var _a;
  var _b = useContext(OrgConfigWizardContext),
    configVersionId = _b.configVersionId,
    setBeforeNext = _b.setBeforeNext,
    selectedLocationId = _b.selectedLocationId,
    setSelectedLocationId = _b.setSelectedLocationId;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'staffing'
  }).t;
  var locationsData = useLocationsAPI(configVersionId)[0];
  var allLocations = useMemo(function () {
    var _a, _b;
    return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
  }, [locationsData.data]);
  var _c = useState({}),
    formMap = _c[0],
    setFormMap = _c[1];
  var _d = useState(undefined),
    globalError = _d[0],
    setGlobalError = _d[1];
  var selectedLocation = useMemo(function () {
    var _a;
    return (_a = allLocations.find(function (l) {
      return l.id === selectedLocationId;
    })) !== null && _a !== void 0 ? _a : null;
  }, [allLocations, selectedLocationId]);
  var _e = useRolesAPI(selectedLocationId),
    rolesData = _e[0],
    fetchRoles = _e[1];
  useEffect(function () {
    if (!selectedLocationId) {
      return;
    }
    fetchRoles();
  }, [selectedLocationId, fetchRoles]);
  useEffect(function () {
    if (!selectedLocationId || !rolesData.data) {
      return;
    }
    setFormMap(function (prev) {
      var _a;
      var _b;
      if ((_b = prev[selectedLocationId]) === null || _b === void 0 ? void 0 : _b.isDirty) return prev;
      var roles = rolesData.data;
      var mappedRoles = roles.length > 0 ? roles.map(mapRoleItemToFormState) : [createEmptyRole()];
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = {
        roles: mappedRoles,
        isDirty: false
      }, _a));
    });
  }, [selectedLocationId, rolesData.data]);
  var handleFormChange = useCallback(function (updater) {
    if (!selectedLocationId) return;
    setGlobalError(undefined);
    setFormMap(function (prev) {
      var _a;
      var _b;
      var current = (_b = prev[selectedLocationId]) !== null && _b !== void 0 ? _b : createDefaultFormState();
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = updater(current), _a));
    });
  }, [selectedLocationId]);
  var handleCopySuccess = useCallback(function () {
    if (selectedLocationId) {
      setFormMap(function (prev) {
        var _a;
        var current = prev[selectedLocationId];
        if (!current) return prev;
        return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = __assign(__assign({}, current), {
          isDirty: true
        }), _a));
      });
    }
    fetchRoles();
  }, [selectedLocationId, fetchRoles]);
  var _f = useStaffingStatusAPI(configVersionId),
    statusData = _f[0],
    fetchStatus = _f[1];
  var configuredLocationIds = useConfiguredLocationIds(fetchStatus, statusData);
  var getLocationStatus = useCallback(function (id) {
    var form = formMap[id];
    if (form) {
      var hasData = form.roles.some(function (r) {
        return !r.isDeleted && !isEmptyNewRole(r);
      });
      return hasData ? 'ok' : 'incomplete';
    }
    return configuredLocationIds.has(id) ? 'ok' : 'incomplete';
  }, [formMap, configuredLocationIds]);
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var allLocationsRef = useRef(allLocations);
  useEffect(function () {
    allLocationsRef.current = allLocations;
  }, [allLocations]);
  /** Validates a single location's roles, returning an error message key result or null when valid. */
  var getRolesValidationError = useCallback(function (form) {
    var hasInvalidRole = form.roles.some(function (r) {
      return !r.isDeleted && !isEmptyNewRole(r) && (!r.roleType || !r.roleAppliesTo || r.roleType === LocationRoleType.Custom && !r.customRoleName.trim());
    });
    if (hasInvalidRole) {
      return t('errors.incompleteRoles', {
        defaultValue: 'Please complete all role fields (role name and role applies to) before continuing.'
      });
    }
    var duplicate = findDuplicateRoleKind(form.roles);
    if (duplicate === 'name') {
      return t('errors.duplicateCustomName', {
        defaultValue: 'Custom role names must be unique. Please rename the duplicate role before continuing.'
      });
    }
    if (duplicate === 'role_type') {
      return t('errors.duplicateRoles', {
        defaultValue: 'Each role name can only be added once. Please remove the duplicate role before continuing.'
      });
    }
    return null;
  }, [t]);
  var rolesToPayload = useCallback(function (form) {
    return form.roles.filter(function (r) {
      return !isEmptyNewRole(r);
    }).map(function (r) {
      return {
        id: r.id,
        roleType: r.roleType,
        roleAppliesTo: r.roleAppliesTo,
        roleName: r.roleType === LocationRoleType.Custom ? r.customRoleName : String(t(ROLE_TYPE_T_KEYS[r.roleType], {
          defaultValue: r.roleType
        })),
        isCustom: r.roleType === LocationRoleType.Custom,
        basedOnCalculation: r.basedOnCalculation,
        isDeleted: r.isDeleted,
        ratio: typeof r.ratio === 'number' && !Number.isNaN(r.ratio) ? r.ratio : null
      };
    });
  }, [t]);
  var persistCurrentLocation = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var form, validationError, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!selectedLocationId) return [2 /*return*/, true];
            form = formMapRef.current[selectedLocationId];
            if (!(form === null || form === void 0 ? void 0 : form.isDirty)) {
              setGlobalError(undefined);
              return [2 /*return*/, true];
            }
            validationError = getRolesValidationError(form);
            if (validationError) {
              setGlobalError({
                message: validationError
              });
              return [2 /*return*/, false];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, saveLocationRoles(selectedLocationId, rolesToPayload(form))];
          case 2:
            _a.sent();
            setFormMap(function (prev) {
              var _a;
              var cur = prev[selectedLocationId];
              if (!cur) return prev;
              return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = __assign(__assign({}, cur), {
                isDirty: false
              }), _a));
            });
            setGlobalError(undefined);
            return [2 /*return*/, true];
          case 3:
            error_1 = _a.sent();
            setGlobalError({
              message: getSaveErrorMessage(error_1, String(t('errors.saveFailed', {
                defaultValue: 'Failed to save support roles. Please try again.'
              })))
            });
            return [2 /*return*/, false];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }, [selectedLocationId, t, getRolesValidationError, rolesToPayload]);
  var _g = usePersistingLocationSelect({
      selectedLocationId: selectedLocationId,
      setSelectedLocationId: setSelectedLocationId,
      persistCurrent: persistCurrentLocation
    }),
    onSelectLocation = _g.onSelectLocation,
    isPersistingSelection = _g.isPersistingSelection;
  useEffect(function () {
    var beforeNextFn = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var fm, locations, _i, locations_1, loc, form, validationError, _a, locations_2, loc, form, error_2;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              fm = formMapRef.current;
              locations = allLocationsRef.current;
              setGlobalError(undefined);
              for (_i = 0, locations_1 = locations; _i < locations_1.length; _i++) {
                loc = locations_1[_i];
                form = fm[loc.id];
                if (!form) continue;
                validationError = getRolesValidationError(form);
                if (validationError) {
                  setSelectedLocationId(loc.id);
                  setGlobalError({
                    message: validationError
                  });
                  return [2 /*return*/, false];
                }
              }
              _b.label = 1;
            case 1:
              _b.trys.push([1, 6,, 7]);
              _a = 0, locations_2 = locations;
              _b.label = 2;
            case 2:
              if (!(_a < locations_2.length)) return [3 /*break*/, 5];
              loc = locations_2[_a];
              form = fm[loc.id];
              if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return [3 /*break*/, 4];
              return [4 /*yield*/, saveLocationRoles(loc.id, rolesToPayload(form))];
            case 3:
              _b.sent();
              _b.label = 4;
            case 4:
              _a++;
              return [3 /*break*/, 2];
            case 5:
              return [2 /*return*/, true];
            case 6:
              error_2 = _b.sent();
              setGlobalError({
                message: getSaveErrorMessage(error_2, String(t('errors.saveFailed', {
                  defaultValue: 'Failed to save support roles. Please try again.'
                })))
              });
              return [2 /*return*/, false];
            case 7:
              return [2 /*return*/];
          }
        });
      });
    };
    setBeforeNext(beforeNextFn);
    return function () {
      return setBeforeNext(null);
    };
  }, [getRolesValidationError, rolesToPayload, setBeforeNext, setSelectedLocationId, t]);
  var checkIsDirty = useCallback(function () {
    return Object.values(formMapRef.current).some(function (form) {
      return form.isDirty;
    });
  }, []);
  useOrgConfigDirtyRegister(checkIsDirty);
  var currentForm = selectedLocationId === null ? null : (_a = formMap[selectedLocationId]) !== null && _a !== void 0 ? _a : null;
  var isLoading = rolesData.requesting;
  return _jsxs(_Fragment, {
    children: [_jsx(ErrorMessageBox, {
      errors: [globalError],
      onClose: function () {
        return setGlobalError(undefined);
      }
    }), _jsx(OrgConfigStepContainer, __assign({
      leftContent: _jsx(LocationListPanel, {
        allLocations: allLocations,
        selectedLocationId: selectedLocationId,
        onSelectLocation: onSelectLocation,
        getLocationStatus: getLocationStatus,
        title: t('locations.title', {
          defaultValue: 'Site locations'
        }),
        description: t('locations.description', {
          defaultValue: 'Select a location to view/edit data.'
        })
      })
    }, {
      children: !selectedLocation || !currentForm ? _jsx(FallbackComponent, __assign({
        requesting: isLoading
      }, {
        children: _jsx(Box, __assign({
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 300
          }
        }, {
          children: _jsx(Typography, __assign({
            color: "text.secondary"
          }, {
            children: t('selectLocation', {
              defaultValue: 'Select a location to configure its support roles.'
            })
          }))
        }))
      })) : _jsx(LocationConfigPanel, {
        form: currentForm,
        locationId: selectedLocationId,
        allLocations: allLocations,
        onChange: handleFormChange,
        onCopySuccess: handleCopySuccess
      })
    })), _jsx(FallbackComponent, {
      requesting: isPersistingSelection,
      overlay: true
    })]
  });
};